/**
 * Created by Jie Gao on 27/03/19.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GGGameConfig} from "../GGGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GGParsedGameData} from "../server/data/GGParsedGameData";
import {TimelineLite, TweenLite} from "gsap";
import {GGGameAssets} from "../GGGameAssets";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {GGParsedInitData} from "../server/data/GGParsedInitData";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IXBomb} from "../server/data/IGGServerData";
import {GGSoundConfig} from "../GGSoundConfig";
import {GGGameModuleConfig} from "../GGGameModuleConfig";
export class WaysAndMultiplier extends BaseView {
    private static totalWays:string = (3 * 3 * 3 * 3 * 3 * 3).toString();
    private _layer:PIXI.Container;
    private _hasWin:boolean = false;
    private _textWays:PIXI.Sprite;
    private _totalNumberOfWays:number[];
    private _totalNumberOfWaysRestore:number;
    private _reelSize:number;
    private _gameAreaSizeNextSpin:number;
    private _betwaysInTotal:PIXI.BitmapText;
    private _isNextRespin:boolean = false;
    private _isRestore:boolean;
    private _bombData:IXBomb;

    private _multiplierHolder:PIXI.Sprite;
    private _multiplierPanel:PIXI.Sprite;
    private _multiplier:PIXI.BitmapText;

    constructor() {
        super();
        this._layer = StageManager.getLayer(GGGameConfig.instance.LAYERS.BET_WAYS.name);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, (event:GameEvent) => this.onGameReady());
    }

    private onInitGameDataParsed(data:GGParsedInitData):void {
        this._isRestore = data.isRestoreState;
        this._totalNumberOfWaysRestore = data.totalNumberOfWays;
        this._bombData = data.xBombs;
        this._reelSize = data.gameAreaSize;
        this._gameAreaSizeNextSpin = data.gameAreaSize;
    }

    protected onGameDataParsed(data:GGParsedGameData):void {
        this._hasWin = data.singleWin > 0;
        this._bombData = data.xBombs;
        this._totalNumberOfWays = data.totalNumberOfWays;
        this._isNextRespin = data.nextMode.indexOf("_AVALANCHE") > -1;
        this._reelSize = data.gameAreaSize;
        this._gameAreaSizeNextSpin = data.gameAreaSizeNextSpin;
        let newWays:number = this._totalNumberOfWays[0];

        let newEvil4SymNumber:number = 0;
        let allEvil4SymNumber:number = 0;

        if(data.topTrain.evil4) {
            const reelSize:number = data.gameAreaSize;

            data.reels[0].forEach((sym:string) => {
                if(sym === data.topTrain.evil4Symbol) {
                    allEvil4SymNumber++;
                }
            });
            const newReel0Size:number = (data.topTrain.evil4multiplier - 1) * allEvil4SymNumber + reelSize;

            let oldReel0Size:number = reelSize;
            if(data.isAvalancheMode) {
                data.newSymbols[0].forEach((sym:string) => {
                    if(sym === data.topTrain.evil4Symbol) {
                        newEvil4SymNumber++;
                    }
                });
                oldReel0Size = (data.topTrain.evil4multiplier - 1) * (allEvil4SymNumber - newEvil4SymNumber) + reelSize;
            }

            if(allEvil4SymNumber > 0) {
                newWays = (newWays / newReel0Size) * oldReel0Size;
                //if(!Number.isInteger(newWays)) {
                //    console.log("this._totalNumberOfWays[0]: " + this._totalNumberOfWays[0]);
                //    console.log("reelSize: " + reelSize);
                //    console.log("newWays: " + newWays);
                //    throw Error("ways is not integer")
                //}
            }
        }

        if(newWays > 0) {
            this.updateBetWays(newWays);
        }
    }

    private onGameReady():void {
        this.updateBetWays()
        if(this._isRestore) {
            if(this._bombData.displayMultiplier > 1) {
                this._multiplier.text = "x" + this._bombData.displayMultiplier.toString();
                this._multiplierHolder.addChild(this._multiplier);
                this._multiplier.visible = true;
            }
        }
    }
    private onBeforeSpinStart():void {
        if(this._isRestore) {
            this._isRestore = false;
            return;
        }
        if(this._isNextRespin) {
            return;
        }
        this._multiplier.visible = false;
    }

    public updateBombMultiplier():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        this._multiplier.text = "x" + this._bombData.displayMultiplier.toString();
        this._multiplier.scale.set(4);

        const multiplierEffect:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("Bomb_Multiplier"));
        multiplierEffect.name = "Bomb_Multiplier";
        multiplierEffect.renderable = false;
        multiplierEffect.position.set(0, 0);

        tl.add([() => {
            this._multiplierHolder.addChild(multiplierEffect);
            this._multiplierHolder.addChild(this._multiplier);
            this._multiplier.visible = true;
            multiplierEffect.renderable = true;
            multiplierEffect.state.setAnimation(0,"Multi_Effect",false);
            GGGameModuleConfig.soundPlayer.playSoundEffect(GGSoundConfig.BOMB_MULTIPLIER);
        },
        TweenLite.fromTo(this._multiplier.scale, 0.1, {x:4,y:4},{x:1,y:1})
        ]);

        tl.add(()=>{
            this._multiplierHolder.removeChild(multiplierEffect);
            multiplierEffect.destroy();
        }, 0.7);
        return tl;
    }

    /*private removeBombMultipliers():void {
        if(!this._multiPliers) {
            this._multiPliers = [];
            return;
        }
        this._multiPliers.forEach((multiplier:PIXI.BitmapText) => {
            multiplier.visible = false;
            this._layer.removeChild(multiplier);
        });
        this._multiPliers = [];
    }

    private addMultiplier(i:number, j:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const flyToMiddleDuration:number = 0.5;
        const flyUp:number = 0.3;
        const multiplier = new PIXI.BitmapText("x1", {
            font : {
                name : "ways",
                size : 40
            }
        });
        this._multiPliers.push(multiplier);

        tl.add(() => {
            const pos:[number, number] = Helper.getSymbolPositions(i, j, true);
            multiplier.x = pos[0];
            multiplier.y = pos[1];
            this._layer.addChild(multiplier);
        }, 0);
        tl.add([
            TweenLite.to(multiplier, flyToMiddleDuration, {x : 360, y : 360}),
            TweenLite.to(multiplier, flyToMiddleDuration, {alpha : 0.7}),
            TweenLite.to(multiplier.scale, flyToMiddleDuration, {x : 5, y : 5})
        ], flyToMiddleDuration + 0.2);
        tl.add([
            TweenLite.to(multiplier, flyUp, {x : this._multiplierHolder.x, y : this._multiplierHolder.y}),
            TweenLite.to(multiplier.scale, flyUp, {x : 1, y : 1})
        ], flyUp + flyToMiddleDuration + 0.2);
        return tl;
    }
*/

    public updateBetWays(betwaysInTotal?:number):void {
        const betways:number = (betwaysInTotal === undefined) ? (this._reelSize ** 6) : betwaysInTotal;
        this._betwaysInTotal.text = betways.toString();
        this._betwaysInTotal.x = 0 - this._betwaysInTotal.width * 0.5;

    }

    protected initAnimations():void {
        const top:number = GGGameConfig.instance.REEL_AREA_POS_Y + GGGameConfig.instance.REEL_AREA_TOP;
        const waysHolder:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("waysHolder")[0]);
        waysHolder.anchor.set(0.5, 1);
        waysHolder.position.set(Helper.getSymbolPositions(5, 0)[0], top);
        this._layer.addChild(waysHolder);

        this._textWays = new PIXI.Sprite(GameResources.getTextures(GGGameAssets.WAYS)[0]);
        this._textWays.x = 0;
        this._textWays.y = -20;
        this._textWays.anchor.set(0.5, 1);
        waysHolder.addChild(this._textWays);

        this._betwaysInTotal = new PIXI.BitmapText(WaysAndMultiplier.totalWays, {
            fontName : "ways",
            fontSize : 30
        });
        this._betwaysInTotal.letterSpacing = -30;
        this._betwaysInTotal.x = 0 - this._betwaysInTotal.width * 1 + 30;
        this._betwaysInTotal.y = -72;
        waysHolder.addChild(this._betwaysInTotal);

        const multiplierHolder:PIXI.Sprite = new PIXI.Sprite();
        multiplierHolder.name ="multiplierHolder";
        multiplierHolder.anchor.set(0.5, 0.5);
        multiplierHolder.position.set(0, top - 161);
        this._layer.addChild(multiplierHolder);
        const multiplierPanel:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("multiplierHolder")[0]);
        multiplierPanel.name ="multiplierPanel";
        multiplierPanel.anchor.set(0.5, 0.5);
        multiplierPanel.position.set(0, 0);
        multiplierHolder.addChild(multiplierPanel);

        this._multiplier = new PIXI.BitmapText("x1", {
            fontName : "multiplierCountup",
            fontSize : 10
        });
        (<PIXI.Point>this._multiplier.anchor).set(0.5, 0.5);
        this._multiplier.x = -2;
        this._multiplier.y = 9;

        this._multiplierHolder = multiplierHolder;
        this._multiplierPanel = multiplierPanel;
        this._multiplier.visible = false;
    }

    protected onResize(resizeData:IResizeData) {
        const top:number = GGGameConfig.instance.REEL_AREA_POS_Y + GGGameConfig.instance.REEL_AREA_TOP;
        const right:number = GGGameConfig.instance.REEL_AREA_POS_X + GGGameConfig.instance.REEL_AREA_WIDTH;
        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this._multiplierHolder.x = right + 63;
            this._multiplierHolder.y = top - 40;
        } else {
            this._multiplierHolder.x = right - 57;
            this._multiplierHolder.y = top - 170;
        }
    }
}

